import { PetSummary } from "./types.ts";
import { PAGE_PATHS } from "./config.ts";

type AdoptablePetPreviewProps = {
  item: PetSummary;
};

export default function AdoptablePetPreview({
  item,
}: AdoptablePetPreviewProps) {
  if (!item) {
    console.warn("AdoptablePetPreview: item is null.");
    return null;
  }

  const petUrl = `${PAGE_PATHS.PET_DETAIL}?pet=${item.id}`;
  // const petUrl = `${PAGE_PATHS.PET_DETAIL}/${item.id}`;

  return (
    <div className="flex flex-col w-full sm:max-w-sm !bg-white rounded overflow-hidden shadow-md">
      <div
        className="relative w-full aspect-[3/4]"
        style={{
          backgroundImage: `url(${item.photo})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 20%",
        }}
      ></div>
      <div className="px-4 py-4">
        <div
          className="text-2xl font-bold text-[#ef3825] mb-4"
          style={{ fontFamily: "Varela Round", fontSize: "25.5px" }}
        >
          <a
            href={petUrl}
            className="text-2xl font-bold text-[#ef3825] cursor-pointer"
          >
            {item.name}
          </a>
        </div>
        <div className="mb-2">
          <strong>Age / Gender</strong> {item.ageFormatted} / {item.sex}
        </div>
        <div className="mb-2">
          <strong>Looks Like</strong> {item.breed}
        </div>
        <div className="mb-2">
          <strong>Location</strong> {item.location}
        </div>
      </div>
      <div className="mt-auto w-full text-center">
        <a
          className={
            "capitalize bg-primary p-4 hover:bg-primary-hover focus:!bg-primary text-[18px] hover:!text-[18px] text-md !text-on-primary visited:text-on-primary w-full inline-block"
          }
          style={{ color: "white", textDecoration: "none", fontWeight: "600" }} //DML: unfotunate hack necessary to over-ride WP site styles
          href={petUrl}
        >
          Meet {item.name}
        </a>
      </div>
    </div>
  );
}
